import React, {useEffect, useRef, useState} from "react";
import axios from "axios";
import swal from "sweetalert";

const checklistOptions = [
    {name: "Állattartás", input: "M16625556499276", id: 2612, checked: false},
    {name: "Hobbi és szabadidő", input: "M16625556499191", id: 2635, checked: false},
    {name: "Számítástechnika", input: "M16625556496930", id: 2627, checked: false},
    {name: "Család és gyermek", input: "M16625556491975", id: 2613, checked: false},
    {name: "Idegen nyelvű könyvek", input: "M16625556499129", id: 2620, checked: false},
    {name: "Szépirodalom", input: "M16625556499494", id: 2628, checked: false},
    {name: "Egészség és életmód", input: "M16625556492738", id: 2614, checked: false},
    {name: "Krimi és thriller", input: "M16625556493290", id: 2621, checked: false},
    {name: "Szórakoztató irodalom", input: "M16625556499783", id: 2629, checked: false},
    {name: "Életrajzok és önéletrajzok", input: "M16625556498419", id: 2615, checked: false},
    {name: "Művészet és média", input: "M16625556495814", id: 2622, checked: false},
    {name: "Társadalomtudomány", input: "M16625556497000", id: 2630, checked: false},
    {name: "Ezotéria", input: "M16625556494796", id: 2616, checked: false},
    {name: "Pszichológia, önfejlesztés", input: "M16625556494464", id: 2623, checked: false},
    {name: "Természettudomány", input: "M16625556497789", id: 2631, checked: false},
    {name: "Fantasy", input: "M16625556492617", id: 2617, checked: false},
    {name: "Romantika és erotika", input: "M16625556496345", id: 2624, checked: false},
    {name: "Történettudomány", input: "M16625556492319", id: 2632, checked: false},
    {name: "Gasztronómia", input: "M16625556496634", id: 2618, checked: false},
    {name: "Sci-fi", input: "M16625556492272", id: 2625, checked: false},
    {name: "Üzlet és gazdaság", input: "M16625556492469", id: 2633, checked: false},
    {name: "Gyermek- és ifjúsági irodalom", input: "M16625556496790", id: 2619, checked: false},
    {name: "Sport", input: "M16625556495932", id: 2626, checked: false},
    {name: "Vallás", input: "M16625556498915", id: 2634, checked: false},
];

export default function Newsletter(props) {
    const gdpr = props.elem?.dataset?.gdpr || props.gdpr;
    const [errors, setErrors] = useState({});
    const [name, setName] = useState("");
    const [email, setEmail] = useState((props.elem?.dataset?.email || props.email) ?? "");
    const [policyAccepted, setPolicyAccepted] = useState(false);
    const [checklist, setChecklist] = useState(checklistOptions);
    const [isLoading, setIsLoading] = useState(false);
    const [seasonalImages, setSeasonalImages] = useState(null);
    const newsletterUrl = props.elem?.dataset?.newsletterFormUrl || props.newsletterUrl;
    const withForm = props.elem?.dataset?.withForm === "true" || props.withForm;
    const form = useRef();

    function handleChange(ev) {
        if (ev.target.name === "name") {
            if (ev.target.value) {
                setErrors((e) => ({...e, name: false}));
            } else setErrors((e) => ({...e, name: true}));
            setName(ev.target.value);
        } else if (ev.target.name === "email") {
            if (ev.target.value) {
                setErrors((e) => ({...e, email: false}));
            } else setErrors((e) => ({...e, email: true}));
            setEmail(ev.target.value);
        }
    }

    function acceptPolicy(e) {
        const {checked} = e.target;
        setPolicyAccepted(checked);
        setErrors((e) => ({...e, policy: false}));
    }

    function submit() {
        const errors = !name || !email || !policyAccepted;
        if (!name) setErrors((e) => ({...e, name: true}));
        if (!email) setErrors((e) => ({...e, email: true}));
        if (!policyAccepted) setErrors((e) => ({...e, policy: true}));
        if (errors) return;
        setIsLoading(true);
        const selectedCategories = checklist
            .map((item) => ({value: item.checked, name: item.name}));
        axios
            .post("/api/newsletter", {
                name,
                email,
                categories: selectedCategories,
            })
            .then((res) => {
                if (res.status === 200) {
                    setName("");
                    setEmail("");
                    setErrors("");
                    setPolicyAccepted(false);
                    setChecklist((c) => c.map((item) => ({...item, checked: false})));

                    setIsLoading(false);

                    if (res.data.isOldSubscriber === true) {
                        swal({
                            title: "Hírlevél feliratkozás frissítve!",
                            text: res.data.message,
                            icon: "info",
                            buttons: {info: "Rendben"},
                        });
                    } else {
                        // swal({
                        //     title: "Sikeres feliratkozás",
                        //     text: res.data.message,
                        //     icon: "success",
                        //     buttons: {success: "Rendben"},
                        // });
                        window.location.href = window.location.pathname+"/sikeres"
                    }
                }
            })
            .catch((err) => {
                console.log(err.response);
                setIsLoading(false);
                swal({
                    title: "Hiba",
                    text: "Legalább egy kategória kiválasztása kötelező.",
                    icon: "error",
                    buttons: { cancel: "Értem" },
                });
            });

        window.Dibook.ping.newsletterSignup({
            name,
            email,
            categories: selectedCategories,
        });
    }

    function toggleItem(index, val) {
        setChecklist((c) => {
            const items = [...c];
            items[index].checked = val;
            return items;
        });
    }

    function toggleAll(event) {
        const all = event.target.checked;
        setChecklist((c) => c.map((item) => ({...item, checked: all})));
    }

    useEffect(() => {
        if(withForm) return;

        axios.get('/api/newsletter/seasonal-images')
            .then((res) => {
                if (res.status === 200) {
                    setSeasonalImages(res.data);
                }
            })
            .catch((err) => {
                console.log(err.response);
            });
    }, [withForm]);

    if (!withForm) {
        if (seasonalImages !== null) {
            return (
                <div className="img-container w-100">
                    <a href="/hirlevel">
                        <picture>
                            <source
                                media="(max-width: 767px)"
                                srcSet={seasonalImages.mobile}
                            />
                            <source
                                media="(max-width: 1024px)"
                                srcSet={seasonalImages.tablet}
                            />
                            <img
                                src={seasonalImages.desktop}
                                alt="newsletter-banner"
                                loading="lazy"
                                className="w-100"
                            />
                        </picture>
                    </a>
                </div>
            );
        }


        return (
            <div className="book-page-newsletter no-form">
                <div className="img-container">
                    <img src="/images/art/newsletter-art-2023.svg" alt="newsletter-art" loading="lazy" />
                </div>
                <img src="/images/art/green-cloud-left.svg" alt="green-cloud-left" className="left-green-cloud"/>
                <img src="/images/art/green-cloud-right.svg" alt="green-cloud-right" className="right-green-cloud"/>
                <img src="/images/art/white-cloud.svg" alt="cloud" className="left-white-cloud"/>
                <img
                    src="/images/art/small-white-cloud.svg"
                    alt="cloud"
                    className="center-white-cloud"
                />
                <img src="/images/art/white-cloud.svg" alt="cloud" className="right-white-cloud"/>
                <div className="newsletter-form-container ml-auto p-0">
                    <div className="newsletter-form">
                        <p className="newsletter-form-title">
                            Iratkozz fel hírlevelünkre 15% kedvezményért és egyedi ajánlatainkért!
                        </p>
                        <a className="btn new-product-action-btn" href="/hirlevel">
                            FELIRATKOZOM
                        </a>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="book-page-newsletter">
            <img src="/images/art/green-cloud-left.svg" alt="green-cloud-left" className="left-green-cloud"/>
            <img src="/images/art/green-cloud-right.svg" alt="green-cloud-right" className="right-green-cloud"/>
            <div className="overlay"/>
            <form
                ref={form}
                method="POST"
                action={newsletterUrl}
                target="_self"
                id="maileon-form"
                className="newsletter-checklist-form"
            >
                {checklist.map((item, i) => (
                    <label key={item.id} className="checkbox-container" htmlFor={item.id}>
                        <input
                            id={item.id}
                            type="checkbox"
                            name={item.input}
                            data-name={item.name}
                            data-type="boolean"
                            value="1"
                            onChange={(e) => toggleItem(i, e.target.checked)}
                            checked={item.checked}
                        />
                        <span className="checkbox-tick"></span>
                        <span className="checkbox-name">{item.name}</span>
                    </label>
                ))}
            </form>
            <div className="newsletter-form-container">
                <div className="newsletter-form">
                    <h2 className="newsletter-form-title">
                        Iratkozz fel kedvenc kategóriáidra, és élvezd a személyre szabott ajánlatainkat!
                        <br /> <br />
                        Ráadásul most egy 15%-os kedvezménykupont is kapsz ajándékba!
                    </h2>
                    <label htmlFor="newsletter-name">
                        <span style={{border: errors.name && "solid 1px #D21312"}}>
                            Keresztnév
                        </span>
                        <input
                            style={{border: errors.name && "solid 1px #D21312"}}
                            type="text"
                            id="newsletter-name"
                            name="name"
                            value={name}
                            onChange={handleChange}
                        />
                    </label>
                    <label htmlFor="newsletter-email">
                        <span style={{border: errors.email && "solid 1px #D21312"}}>
                            E-mail-cím
                        </span>
                        <input
                            style={{border: errors.email && "solid 1px #D21312"}}
                            type="text"
                            id="newsletter-email"
                            name="email"
                            value={email}
                            onChange={handleChange}
                        />
                    </label>
                    <label className="checkbox-container">
                        <input type="checkbox" onChange={toggleAll}/>
                        <span className="checkbox-tick"></span>
                        <span className="checkbox-name">Az összes érdekel.</span>
                    </label>

                    <label className="checkbox-container">
                        <input type="checkbox" checked={policyAccepted} onChange={acceptPolicy}/>
                        <span className="checkbox-tick"></span>
                        <span
                            className="checkbox-name"
                            style={{color: errors.policy && "#D21312"}}
                        >
                            Az
                            <a
                                href={gdpr}
                                style={{
                                    fontWeight: 700,
                                    color: errors.policy ? "#D21312" : "white",
                                }}
                                rel="noreferrer"
                                target="_blank"
                            >
                                {" "}
                                Adatvédelmi Tájékoztatót{" "}
                            </a>
                            elolvastam és elfogadom.
                        </span>
                    </label>
                    <button
                        className="btn new-product-action-btn"
                        disabled={isLoading}
                        onClick={submit}
                    >
                        FELIRATKOZOM
                    </button>
                </div>
            </div>
        </div>
    );
}
